// extracted by mini-css-extract-plugin
export default {"contact_btn":"contactUsFloating_contact_btn__UCOGn"};